import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './CallToAction.css';
import consultantPhoto from '../assets/photo_linkdin.webp';

function CallToAction() {
  const { t } = useTranslation();

  return (
    <section className="call-to-action">
      <div className="cta-content">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t('call_to_action.title')}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="cta-subtitle"
        >
          {t('call_to_action.subtitle')}
        </motion.p>

        <div className="cta-consultant-section">
          <motion.div
            className="consultant-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.3 }}
          >
            <motion.div
              className="consultant-photo"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <img src={consultantPhoto} alt=" M.Sc. Ahmed Tahhan - Consultant" />
            </motion.div>

            <div className="consultant-info">
              <h3 className="consultant-name">M.Sc. Ahmed Tahhan</h3>
              <p className="consultant-title">{t('call_to_action.consultant_role')}</p>
              <div className="consultant-contact">
                <a href="tel:+49-1778663796" className="cta-button cta-call">
                  <span className="button-icon">📞</span>
                  {t('call_to_action.call_now')}
                </a>
                <Link to="/our_cost" className="cta-button cta-pricing">
                  {t('call_to_action.view_pricing')}
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
